import { FormHandles } from '@unform/core';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthLayout } from '../../../../components/AuthLayout';
import { Button } from '../../../../components/Button';
import { useAuth } from '../../../../hooks/auth';
import { useToast } from '../../../../hooks/toast';
import { api } from '../../../../services/api';

import { Checkbox, ContainerCheckboxBox, Form } from './styles';

const AcceptTerms: React.FC = () => {
  const navigate = useNavigate();
  const { user, updateUser } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [enableSubmit, setEnableSubmit] = useState(false);

  useEffect(() => {
    if (user?.privacity && user?.terms_accepted) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  const handleEnableOrDisableSubmit = useCallback(() => {
    setEnableSubmit(
      !!formRef.current?.getFieldValue('privacity') &&
        !!formRef.current?.getFieldValue('terms_accepted'),
    );
  }, []);

  const handleSubmit = useCallback(async () => {
    try {
      await api.patch('users/accept-terms', {
        privacity: true,
        termsAccepted: true,
      });

      // Reconsulta o usuário completo (com gym/permissions/features) em
      // vez de usar a resposta do accept-terms direto -- ela só devolve o
      // usuário "cru" (mesma limitação de UpdateUserService), sem isso o
      // localStorage perderia `features` e travaria os gates de
      // requiredFeature logo na sequência.
      const response = await api.get('users');
      await updateUser(response.data);

      const hasPlatformPermission = !!response.data.permissions?.includes(
        'manage_platform_gyms',
      );

      navigate(hasPlatformPermission ? '/admin/gyms' : '/dashboard', {
        replace: true,
      });
    } catch {
      addToast({
        type: 'error',
        title: 'Erro ao confirmar',
        description:
          'Não foi possível registrar sua confirmação. Tente novamente.',
      });
    }
  }, [addToast, navigate, updateUser]);

  return (
    <AuthLayout
      eyebrow="Atualização importante"
      title={
        <>
          ATUALIZAMOS NOSSOS <span>TERMOS</span>
        </>
      }
      subtitle="Para continuar usando a plataforma, confirme que você leu e concorda com os documentos abaixo."
    >
      <Form ref={formRef} onSubmit={handleSubmit}>
        <ContainerCheckboxBox>
          <Checkbox
            name="privacity"
            id="privacity"
            onChange={handleEnableOrDisableSubmit}
          />
          <label htmlFor="privacity">
            Li e aceito as{' '}
            <a
              href={`${process.env.REACT_APP_SITE_URL}/privacy`}
              target="_blank"
              rel="noopener noreferrer"
            >
              políticas de privacidade
            </a>{' '}
            da plataforma TRENZOX.
          </label>
        </ContainerCheckboxBox>

        <ContainerCheckboxBox>
          <Checkbox
            name="terms_accepted"
            id="terms_accepted"
            onChange={handleEnableOrDisableSubmit}
          />
          <label htmlFor="terms_accepted">
            Li e aceito os{' '}
            <a
              href={`${process.env.REACT_APP_SITE_URL}/terms`}
              target="_blank"
              rel="noopener noreferrer"
            >
              termos de uso
            </a>{' '}
            da plataforma TRENZOX.
          </label>
        </ContainerCheckboxBox>

        <Button name="submit" value="Continuar" disabled={!enableSubmit} />
      </Form>
    </AuthLayout>
  );
};

export { AcceptTerms };
